import BennesController from './bennes.controller';

export default {
    template: require('./bennes.html'),
    controller: BennesController
};
